exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".example-container {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column; }\n\n.example-container > * {\n  width: 50%; }\n\n.example-container form {\n  margin-bottom: 20px; }\n\n.example-container form > * {\n  margin: 5px 0; }\n\n.example-container .mat-radio-button {\n  margin: 0 5px; }\n\n.alinhamento {\n  margin-top: 10px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: start;\n      justify-content: start;\n  -ms-flex-align: center;\n      align-items: center; }\n\n.alignCheck {\n  margin-left: 20px; }\n\n.example-container-table {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  min-width: 300px; }\n\n.mat-table {\n  overflow: auto;\n  max-height: 500px; }\n\n.mat-header-cell.mat-sort-header-sorted {\n  color: black; }\n\np {\n  margin-top: 10px; }\n\n.example-full-width {\n  width: 100%; }\n\n.help_btn {\n  outline: none;\n  color: #17aa5d; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/temporalidade/temporalidade.component.scss
// module id = ../../../../../src/app/temporalidade/temporalidade.component.scss
// module chunks = main